import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

/**
 * Shared centered-modal shell — one consistent look for every create/edit
 * dialog (rounded corners, title + optional subtitle, close button, footer).
 *
 * Pass `actions` for a footer (e.g. Cancel / Save buttons). Dialogs whose body
 * already contains its own submit button can omit `actions`.
 */
function ModalShell({ open, onClose, title, subtitle, maxWidth, actions, children }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        px={3}
        pt={3}
        pb={1}
      >
        <MDBox>
          <MDTypography variant="h5" fontWeight="bold">
            {title}
          </MDTypography>
          {subtitle && (
            <MDTypography variant="button" color="text" fontWeight="regular">
              {subtitle}
            </MDTypography>
          )}
        </MDBox>
        <IconButton onClick={onClose} size="small" sx={{ mt: -0.5, mr: -1 }} aria-label="Close">
          <Icon>close</Icon>
        </IconButton>
      </MDBox>

      <DialogContent>{children}</DialogContent>

      {actions && <DialogActions sx={{ px: 3, pb: 3 }}>{actions}</DialogActions>}
    </Dialog>
  );
}

ModalShell.defaultProps = {
  subtitle: null,
  maxWidth: "sm",
  actions: null,
};

ModalShell.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  maxWidth: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default ModalShell;
